<template>
	<div class="ChatTopBar">


		<div class="ChatTopBarLeft">
			<ul>
				<li class="backBtn" @click="goBack()">
					<img src="../../assets/icon/next-arrow.png" alt="go back">
				</li>
				<li class="ChatTopBarUserDesc">
					<img alt="commaful-logo" src="../../assets/images/chat-user1.png" />
					<div class="TopBarUserDes groupTopBar">
						<h3>Highzone AF</h3>
						<p>Last seen 11.43 AM</p>
					</div>
				</li>
	            <group-dropdown class="ChatTopLeftBtnWrp">
	                <div class="ChatTopLefttBtn" slot="title">
						<img alt="commaful-logo" src="../../assets/icon/group-icon.svg" />
						<span>8 Person</span>
	                </div>

	                <template>
                    	<div class="addToGroup">
	                        <input type="text" placeholder="Find your friend">
							<img alt="search" src="../../assets/icon/search-icon.svg" />
                    	</div>
                    	<div class="uses-group-list">
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                    <a href="#">
		                    	<img src="../../assets/images/chat-user1.png" class="profileImg">
		                    	<h3>Frederick Byrd</h3>
		                    	<img src="../../assets/icon/close.png" class="delUsrFrmGrp">
		                    </a>
		                </div>
                    	<div class="addToGroupbtn">
	                       <button type="button">Add Friends to Group</button>
                    	</div>
	                </template>
	            </group-dropdown>
			</ul>
		</div>


		<div class="ChatTopBarRight">
			<block-unblock></block-unblock>
		</div>


	</div>
</template>


<script>
  export default {

      name: "group-chat-topbar",

      data() {
          return {
          	
          }
      },

      methods: {
      	
      	goBack(){
      		return this.$router.push('/inbox');
      	}

      },

        mounted() {
           

        },

  }
</script>



<style>

	@import '../../assets/css/chat-top-bar.css';

	@media only screen and (max-width: 480px) {
		.ChatTopBarLeft .dropdown-menu:after{
			display: none;
		}
		.groupTopBar>p{
			display: none !important;
		}
		.groupTopBar>h3 {
		    margin-top: -26px;
		}

		.ChatTopLeftBtnWrp.dropdown {
		    width: auto;
		    height: auto;
		    line-height: initial;
		    background: transparent;
		    position: absolute;
		    margin-left: 25px;
		    margin-top: 9px;
		}
		.ChatTopLefttBtn>img {
		    width: 12px;
		}
		.ChatTopLefttBtn span {
		    top: -1px;
		    margin-left: 4px;
		}
		.ChatTopLeftBtnWrp .dropdown-menu {
			position: fixed;
		    left: 0;
		    width: 100%;
		    background: #F1F2F4;
		}


		.addToGroupbtn button {
		    position: absolute;
		    bottom: 35px;
		    right: 40px;
		    width: 80%;
		}
		.uses-group-list {    
			max-height: 72vh;
		    margin-bottom: 0px;
		    box-sizing: border-box;
		    padding-bottom: 90px;
		}
		.uses-group-list:after {
		    position: fixed;
		    content: "";
		    left: 0;
		    bottom: 0;
		    width: 100%;
		    height: 100px;
		    background-image: linear-gradient(to bottom, #ffffff00, #fbfbfb75, #f6f6f6a3, #f2f2f2b8, #ffffffbf);
		}
	}

	@media only screen and (max-width: 450px) {
		.uses-group-list {
			max-height: 63vh;
		}
		.uses-group-list:after {
		    height: 90px;
		}
		.addToGroupbtn button {
		    position: absolute;
		    bottom: 55px;
		    right: 40px;
		    width: 80%;
		}
	}

</style>